"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Tooltip = _interopRequireWildcard(require("../../../../../../../ui/Tooltip"));
var _Button = _interopRequireWildcard(require("../../../../../../../ui/Button"));
var _selectors = require("../../../../store/selectors");
var _copySmall = _interopRequireDefault(require("../../img/copy-small.svg"));
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var OperatorCode = function OperatorCode(_ref) {
  var subOperatorName = _ref.subOperatorName,
    onCopyOfferURL = _ref.onCopyOfferURL;
  var _useTranslation = (0, _reactI18next.useTranslation)('OFFER_DETAILS', 'CONFIRM_MODAL'),
    t = _useTranslation.t;
  var fosterLinkOfOffer = (0, _reactRedux.useSelector)(_selectors.getFosterLinkOfOffer);
  var isEnabledCopyURL2Buffer = (0, _reactRedux.useSelector)(_selectors.getIsEnabledCopyURL2Buffer);
  var offer = (0, _reactRedux.useSelector)(_selectors.getBootstrapOffer);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.root
  }, fosterLinkOfOffer && /*#__PURE__*/_react.default.createElement("a", {
    className: _styles.default.fosterLink,
    href: fosterLinkOfOffer,
    rel: "noreferrer",
    target: "_blank"
  }, "f"), subOperatorName && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, subOperatorName, ' '), t('OPERATOR_CODE_TITLE', {
    code: offer.id
  }), isEnabledCopyURL2Buffer && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    content: t('COPY_BUTTON_HINT'),
    placement: _Tooltip.PLACEMENTS.TOP,
    trigger: [_Tooltip.TRIGGERS.HOVER]
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    activeTheme: _Button.THEMES.PURPLE,
    background: "transparent",
    height: _Button.HEIGHTS.FLUID,
    width: _Button.WIDTHS.FLUID,
    icon: _copySmall.default,
    onClick: onCopyOfferURL
  })));
};
OperatorCode.propTypes = {
  subOperatorName: _propTypes.default.string,
  onCopyOfferURL: _propTypes.default.func.isRequired
};
var _default = exports.default = (0, _react.memo)(OperatorCode);